<template>
  <div>
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar" timeout="5000" :value="true" :color="snackbarclr" absolute outlined top right>
      <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
      <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
    </v-snackbar>
    <v-app-bar dense style="background-color: white; position: fixed; z-index: 3" width="100%" permanent class="elevation-0 px-md-2 overflow-hidden" outlined>
      <img src="@/assets/Zebu Logo.svg" width="80px" />
      <v-spacer></v-spacer>
      <v-row class="flex-row-reverse mr-0 mr-md-4 pt-4">
        <v-list nav>
          <v-list-item-group class="d-flex">
            <v-list-item to="/ap/dashboard" class="px-4 mx-1 mb-0 rounded-t-lg">
              <v-list-item-title class="font-weight-medium text-capitalize"> AP </v-list-item-title>
            </v-list-item>
            <v-list-item to="/rekyc/dashboard" class="px-4 mx-1 mb-0">
              <v-list-item-title class="font-weight-medium text-capitalize"> ReKyc </v-list-item-title>
            </v-list-item>
            <v-list-item to="/ekyc/dashboard" class="px-4 mx-1 mb-0 rounded-t-lg">
              <v-list-item-title class="font-weight-medium text-capitalize"> EKyc </v-list-item-title>
            </v-list-item>
            <!-- <v-list-item to="/ekyc/man-dashboard" class="px-4 mx-1 mb-0 rounded-t-lg">
              <v-list-item-title class="font-weight-medium text-capitalize">
                man-EKyc
              </v-list-item-title>
            </v-list-item> -->
            <v-list-item to="/uploads" class="px-4 mx-1 mb-0 rounded-t-lg">
              <v-list-item-title class="font-weight-medium text-capitalize"> Reports </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-row>

      <v-menu open-on-hover down offset-y transition="slide-y-transition" class="rounded-xl">
        <template v-slot:activator="{on, attrs}">
          <v-btn class="my-auto" icon v-bind="attrs" v-on="on">
            <v-avatar tile color="transparent" class="" size="36">
              <span class="headline font-weight-bold text-center">{{ uemail ? uemail.slice(0, 1) : "" }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-card class="py-2 px-4 rounded-xl elevation-0" width="300">
          <v-list-item class="pl-0 pb-3">
            <v-list-item-avatar tile class="rounded-lg">
              <v-avatar tile color="#F5F5F5" size="40">
                <span class="headline font-weight-bold text-center">{{ uname ? uname.slice(0, 1) : "" }}</span>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{ uname }}</v-list-item-title>
              <v-list-item-subtitle class="font-weight-bold">{{ uemail }}</v-list-item-subtitle>
              <v-list-item-subtitle class="font-weight-bold">{{ uuid }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-btn @click="logout()" class="elevation-0 mb-2" block text color="#2962FF" style="background-color: #e5ecff !important">
            <span class="font-weight-bold">Logout</span>
          </v-btn>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-dialog persistent v-model="bottomload" width="380">
      <v-card class="elevation-0 rounded-lg">
        <v-toolbar dense class="elevation-0">
          <span class="font-weight-bold title">Enable location</span>
        </v-toolbar>
        <img width="100%" class="px-6" src="@/assets/location.svg" alt="" />

        <v-card-text class="py-2 title"> To continue, you must allow the <b>admin dashboard</b> to access your location for security purposes. Failure to do so will result in you being unable to access this application. </v-card-text>
        <v-card-actions class="pb-4">
          <v-btn @click="getLocation()" block color="#B388FF" class="elevation-0 font-weight-bold rounded-pill white--text text-none" height="40"> Allow Location Services </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay persistent :value="snackbar"></v-overlay>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    snackbar: false,
    snackbarclr: "default",
    snackmsgbar: "",

    uemail: null,
    uuid: null,
    uname: null,
    bottomload: true,
    geolocat: null,
  }),
  created() {
    let list = atob(localStorage.getItem("stapilist"));
    this.uemail = localStorage.getItem("email");
    this.uuid = localStorage.getItem("empcode");
    this.uname = localStorage.getItem("name");
    let sess = sessionStorage.getItem("sess");

    if (list && this.uemail && this.uuid && this.getemailInList(this.uemail, "emailId", list) && this.getemailInList(this.uuid, "uid", list)) {
      //
    } else {
      let config = {
        method: "get",
        url: `https://dwld.zebuetrade.com/gen?id=${localStorage.getItem("empcode")}`,
        headers: {},
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          if (response.data.link != "Invalid") {
            localStorage.setItem("empcode", response.data.user);
            localStorage.setItem("mode", response.data.name);
          } else {
            axiosThis.$router.push("/");
          }
          if (sess != btoa(new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10) + axiosThis.uuid)) {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "warning";
            axiosThis.snackmsgbar = "session expired, please log in again";
            sessionStorage.clear();
            setTimeout(() => {
              this.$router.push("/");
            }, 2000);
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "#FF1717";
          axiosThis.snackmsgbar = error.message ? error.message : error;
          setTimeout(() => {
            // this.$router.push('/')
          }, 2000);
        });
    }

    this.getLocation();
  },
  methods: {
    getemailInList(email, value, list) {
      const rawData = JSON.parse(list);
      return rawData.some((item) => item[value].toUpperCase() === email.toUpperCase());
    },
    openLoc() {
      if (this.geolocat) {
        this.bottomload = false;
      } else {
        this.bottomload = true;
      }
    },
    getLocation() {
      if (navigator.geolocation.getCurrentPosition(this.showPosition)) {
        navigator.geolocation.getCurrentPosition(this.showPosition);
        this.bottomload = false;
      } else {
        this.geolocat = null;
        this.openLoc();
      }
    },

    showPosition(position) {
      this.geolocat = position.coords;
      this.bottomload = false;
      this.openLoc();
    },
    logout() {
      localStorage.clear();
      this.$router.push("/");
    },
  },
};
</script>
